import React, {useEffect} from 'react';
import { useFormContext } from '../Provider';
import useValidators from '../Validators/useValidator';
import CommonFieldWrapper from './CommonFieldWrapper';
import { classNames } from '../../../Services/helpers';
import { useConditionalHelper } from '../Conditional';
import { useFieldPanelHelper } from '../../Containers/Accordion/Panel';
import { AsYouType, parsePhoneNumber } from 'libphonenumber-js'

const fallbackValue = '';

const PhoneNumber = ({label, name, help, onChange, placeholder, prefix, suffix, suffixOnClick, disabled, validators}) => {
    const { formData, updateField, updateValidity, isValidating, isSubmitting, formDisabled } = useFormContext();
    const value = formData[name] ?? fallbackValue;
    const {isValid, error} = useValidators(value, validators, name, updateValidity);

    useConditionalHelper(name);
    useFieldPanelHelper(name, value, isValid);

    const handleChange = (e) => {
        const formattedValue = new AsYouType('GB').input(e.target.value);
        updateField(name, formattedValue);
        onChange && onChange(formattedValue);
    }

    useEffect(() => {
        if (!value) {
            return;
        }
        const formatted = parsePhoneNumber(value, 'GB')?.formatNational() ?? null;
        if (!formatted) {
            return;
        }

        updateField(name, formatted);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const isDisabled = formDisabled || disabled || isSubmitting;

    return <CommonFieldWrapper {...{label, name, help, value, isValid, isValidating, error, validators, isDisabled}}>

        <div className="relative flex flex-row">
            <div className="pointer-events-none inset-y-0 left-0 flex items-center pr-1">
                <span className="fill-gray-400 text-gray-400 sm:text-sm">{prefix}</span>
            </div>

            <input className="block w-full border-0 p-0 text-gray-900 placeholder:text-gray-400 focus:ring-0 sm:text-sm sm:leading-6 disabled:text-gray-400 disabled:bg-gray-100"
                type="tel"
                // pattern="\d*"
                value={value}
                onChange={handleChange}
                placeholder={placeholder}
                disabled={isDisabled}
            />

            <div className={classNames(
                    'inset-y-0 right-0 flex items-center pl-1',
                    suffixOnClick ? 'cursor-pointer' : 'pointer-events-none'
                )}
                onClick={() => suffixOnClick && suffixOnClick()}
            >
                <span className="fill-gray-400 text-gray-400 sm:text-sm">{suffix}</span>
            </div>
        </div>

    </CommonFieldWrapper>
}

export default PhoneNumber;
